import { BaseModel } from "@blue-chip/core";
import Project from "./Project";
import PurchaseOrder from "./PurchaseOrder";

export default class Currency extends BaseModel {
  static get hasMany() {
    return [Project, PurchaseOrder];
  }
}
